import { useStaticQuery, graphql } from 'gatsby';
import { useMemo } from 'react';

export type PawsBreeds = Queries.PawsBreedQuery['allPawsBreed']['nodes'];

export function useBreed(speciesId = ''): {
  breeds: PawsBreeds;
  getBreeds: (id: string) => PawsBreeds;
} {
  const { allPawsBreed } = useStaticQuery(graphql`
    query PawsBreed {
      allPawsBreed {
        nodes {
          id: remoteId
          name
          speciesId
          breedGroupId
        }
      }
    }
  `);

  const breeds = useMemo(
    () =>
      (allPawsBreed.nodes as PawsBreeds).filter(
        (item) => item.speciesId === speciesId
      ),
    [allPawsBreed.nodes, speciesId]
  );

  const getBreeds = (id: string): PawsBreeds =>
    (allPawsBreed.nodes as PawsBreeds).filter((item) => item.speciesId === id);

  return { breeds, getBreeds };
}
